export default __webpack_public_path__ + "static/flight-delay-d90d777763c93fc019df7dcd928aa852.jpg";